module.exports = __webpack_public_path__ + "components/flag/static/square/nl-1ece319a036a5604467fe28b3fcd3131.svg";